// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c5eaf93b","952":"d7a323e4"}[chunkId] + ".chunk.js";
};